import { Button } from "@/components/ui/button"
import { useState } from "react"
import { ArrowRight } from "lucide-react"
import { DemoBookingModal } from "./demo-booking-modal"

export function CTASection() {
  const [demoModalOpen, setDemoModalOpen] = useState(false)

  return (
    <>
      <section className="py-20 lg:py-28 bg-gradient-to-b from-[#faf7fb] to-[#f5f0f7]">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h2 className="text-3xl font-bold tracking-tight text-[#2d2d3a] sm:text-4xl lg:text-5xl mb-2">
              Ready to Turn Data Into Your
            </h2>
            <h2 className="text-3xl font-bold tracking-tight sm:text-4xl lg:text-5xl mb-6">
              <span className="bg-[linear-gradient(135deg,#a63083,#bf406a)] bg-clip-text text-transparent">
                Competitive Edge?
              </span>
            </h2>

            <p className="text-lg text-[#6b6b7b] max-w-2xl mx-auto mb-10">
              Join 100+ enterprises already transforming their data operations with Vorro's VIIA platform.
            </p>

            {/* CTA Button */}
            <Button 
              size="lg"
              onClick={() => setDemoModalOpen(true)}
              className="bg-[linear-gradient(135deg,#a63083,#bf406a)] hover:opacity-90 text-white font-medium px-8 h-14 text-lg rounded-xl"
            >
              Talk to an Expert
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
          </div>
        </div>
      </section>

<DemoBookingModal open={demoModalOpen} onOpenChange={setDemoModalOpen} />
    </>
  )
}
